module.exports = __webpack_public_path__ + "static/img/contact1.9a26449.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mastheads/contact1.jpg
// module id = E3eH
// module chunks = 1